import Card from 'reactstrap/lib/Card'

import styled, { DefaultTheme, css } from 'styled-components'

const containerModifiers = {
  default: () => css``,
  borderWarning: (theme: DefaultTheme) => css`
    outline: 1px solid ${theme.colors.warning};
  `,
  /**
   * Moldura do card como o desenho do offsite a define, em tokens Shoreline —
   * `apps/offsite/v2.html`, regra `.review-card`.
   *
   * É template e não o `default` de propósito: o `Panel` é a moldura de mais de
   * cem telas fora de retail media, e trocar o padrão redesenharia o produto
   * inteiro em vez de alinhar os painéis de campanha.
   *
   * Os seletores são de filho direto porque painel dentro de painel existe
   * — tabela de produtos, por exemplo —, e uma regra solta em `.card-body`
   * venceria a do painel de dentro por ordem de folha, que é instável.
   */
  shoreline: () => css`
    margin-bottom: var(--sl-space-4) !important;

    border: var(--sl-border-base);
    border-radius: var(--sl-radius-3);
    box-shadow: none;

    --bs-card-inner-border-radius: var(--sl-radius-3);

    > .card-header {
      padding: var(--sl-space-4) var(--sl-space-5);

      background: var(--sl-bg-base);
      border-bottom: var(--sl-border-base);

      .title {
        font: var(--sl-text-display-3-font);
        color: var(--sl-fg-base);
      }

      .description {
        font: var(--sl-text-body-font);
        color: var(--sl-fg-base-soft);
      }
    }

    > .collapse > .card-body,
    > .collapsing > .card-body {
      padding: var(--sl-space-5);

      &.no-padding {
        padding: 0;
      }
    }
  `,
  disabled: () => css`
    opacity: 0.4;
    user-select: none;
    pointer-events: none;
  `
}

export const Container = styled(Card)<PanelContainerProps>`
  ${({ theme, template, disabled }) => css`
    width: 100%;
    margin-right: 0 !important;
    margin-bottom: 0.5rem !important;

    /* O tema sobrescreve o border-radius do .card com --bs-border-radius, então
       as variáveis do card do Bootstrap não bastam aqui. */
    border-radius: 0.5rem;

    --bs-card-inner-border-radius: 0.5rem;

    .card-header {
      padding: 0.55rem 1rem;
    }

    /* Seção fechada: o header é o único filho, então também é ":last-child" e
       o Bootstrap não tem regra de raio pra esse caso (só cobre ":first-child").
       Sem isso, os cantos inferiores ficam retos com a seção fechada. Evita
       "overflow: hidden" no container, que cortaria dropdown/tooltip/popover
       de qualquer tela que usa Panel. */
    .card-header:last-child {
      border-radius: var(--bs-card-inner-border-radius);
    }

    ${disabled && containerModifiers.disabled()}
    ${template && containerModifiers?.[template](theme)}
  `}
`
